module.exports = "<div class=\"brushHeader\">\n  <span><img src=\"./assets/images/brush-title.svg\" class=\"imgcommande\" ></span>\n  <h1 class=\"cerba-h1\" id=\"cm_titre\" translate=\"TITLES.general\"></h1>\n\n</div>\n<div class=\"menu-component-row\" fxLayout=\"row\">\n  <menu-component fxFlex></menu-component>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/header/header.component.html
// module id = ../../../../../src/app/pages/cerba/header/header.component.html
// module chunks = 0